'use strict';
/* istanbul ignore next */
/**
 * Abstract class that defines expected interface for DAO
 */
define([], function () {
  function AbstractDAO() {
    throw new Error('Cannot instantiate abstract class.');
  }

  let abstractMethod = function () { throw new Error('Abstract method.'); };

  /*
   * methods of interface that we want to get inherited
   */
  AbstractDAO.prototype.serviceHandshake = abstractMethod;
  AbstractDAO.prototype.getFolderData = abstractMethod;
  AbstractDAO.prototype.setAuthToken = abstractMethod;
  AbstractDAO.prototype.getAuthToken = abstractMethod;
  AbstractDAO.prototype.getSessionId = abstractMethod;
  AbstractDAO.prototype.setSessionId = abstractMethod;
  AbstractDAO.prototype.setOriginId = abstractMethod;
  AbstractDAO.prototype.getOriginId = abstractMethod;
  AbstractDAO.prototype.getMinutesBeforeRelogin = abstractMethod;
  AbstractDAO.prototype.setMinutesBeforeRelogin = abstractMethod;
  AbstractDAO.prototype.getLoginData = abstractMethod;
  AbstractDAO.prototype.setLoginData = abstractMethod;
  AbstractDAO.prototype.getUserId = abstractMethod;
  AbstractDAO.prototype.setGdsClientType = abstractMethod;
  AbstractDAO.prototype.getGdsClientType = abstractMethod;
  AbstractDAO.prototype.setClientString = abstractMethod;
  AbstractDAO.prototype.getClientString = abstractMethod;
  AbstractDAO.prototype.updateLoginInformation = abstractMethod;
  AbstractDAO.prototype.clearLoginInformation = abstractMethod;
  AbstractDAO.prototype.setSessionListener = abstractMethod;
  AbstractDAO.prototype.getStorageUsage = abstractMethod;
  AbstractDAO.prototype.uploadFile = abstractMethod;
  AbstractDAO.prototype.getDownloadURI = abstractMethod;
  AbstractDAO.prototype.createFolder = abstractMethod;
  AbstractDAO.prototype.rename = abstractMethod;
  AbstractDAO.prototype.move = abstractMethod;
  AbstractDAO.prototype.delete = abstractMethod;
  AbstractDAO.prototype.logout = abstractMethod;
  AbstractDAO.prototype.permanentlyDelete = abstractMethod;
  AbstractDAO.prototype.permanentlyDeleteAll = abstractMethod;
  AbstractDAO.prototype.restore = abstractMethod;
  AbstractDAO.prototype.getTrashData = abstractMethod;
  AbstractDAO.prototype.getShowHidden = abstractMethod;
  AbstractDAO.prototype.setShowHidden = abstractMethod;
  AbstractDAO.prototype.getShowShared = abstractMethod;
  AbstractDAO.prototype.getApplicationId = abstractMethod;
  AbstractDAO.prototype.setApplicationId = abstractMethod;
  AbstractDAO.prototype.copy = abstractMethod;
  AbstractDAO.prototype.isValidSharePermission = abstractMethod;
  AbstractDAO.prototype.getRecipientRecommendations = abstractMethod;
  AbstractDAO.prototype.createPersonalSharingInvitation = abstractMethod;
  AbstractDAO.prototype.createOpenSharingInvitation = abstractMethod;
  AbstractDAO.prototype.getOpenSharingInvitations = abstractMethod;
  AbstractDAO.prototype.revokeOpenSharingInvitation = abstractMethod;
  AbstractDAO.prototype.getPendingSharingInvitations = abstractMethod;
  AbstractDAO.prototype.getAcceptedSharingInvitations = abstractMethod;
  AbstractDAO.prototype.getSharingCollaborators = abstractMethod;
  AbstractDAO.prototype.revokeSharingPermission = abstractMethod;
  AbstractDAO.prototype.acceptSharingInvitation = abstractMethod;
  AbstractDAO.prototype.declineSharingInvitation = abstractMethod;
  AbstractDAO.prototype.createPersonalFromOpenSharingInvitation = abstractMethod;
  AbstractDAO.prototype.getFolderSettings = abstractMethod;
  AbstractDAO.prototype.search = abstractMethod;
  AbstractDAO.prototype.getUserProfileSettings = abstractMethod;
  AbstractDAO.prototype.loadUserProfileSettings = abstractMethod;
  AbstractDAO.prototype.saveUrlAsFile = abstractMethod;
  AbstractDAO.prototype.getFolderOnlyData = abstractMethod;
  AbstractDAO.prototype.previewInvitation = abstractMethod;
  AbstractDAO.prototype.previewFile = abstractMethod;
  AbstractDAO.prototype.getInvitation = abstractMethod;
  AbstractDAO.prototype.getPreviewInvitation = abstractMethod;
  AbstractDAO.prototype.copyFolderFromInvitation = abstractMethod;
  AbstractDAO.prototype.updateRecipientInvitations = abstractMethod;
  AbstractDAO.prototype.searchByFileName = abstractMethod;

  return AbstractDAO;
});